import BoundingBox from 'boundingbox';

export const getCentroidFromSearchCookie = (
    cookie: string
): { lat: number; lon: number } | null => {
    try {
        const coordChars = '([\\d-.]*)';
        const result = new RegExp(
            `rect=${coordChars}%2C${coordChars}%2C${coordChars}%2C${coordChars}&`
        ).exec(cookie);

        const [, minlat, minlon, maxlat, maxlon] = result ?? [];

        if (!minlat || !minlon || !maxlat || !maxlon) {
            return null;
        }

        const boundingRect = new BoundingBox({
            minlat: parseFloat(minlat),
            minlon: parseFloat(minlon),
            maxlat: parseFloat(maxlat),
            maxlon: parseFloat(maxlon),
        });

        const center = boundingRect.getCenter();

        return center;
    } catch (e) {
        // eslint-disable-next-line no-console
        console.error('Failed to obtain centroid from search cookie', e);
        return null;
    }
};
